import { displayMap } from "../../lib/format";

type T = (k: string, p?: Record<string, string | number>) => string;

/** Название строки матча: реальная карта или честное объяснение, почему её нет. */
export function matchTitle(t: T, map: string | null | undefined, status: string): string {
  if (map) return displayMap(map);
  return status === "waiting" ? t("home.map_pending") : t("home.map_none");
}

/** Исход или этап: для незавершённого матча показываем фазу, а не пустой результат. */
export function matchState(t: T, status: string, outcome: "win" | "loss" | "draw" | "pending"): string {
  if (outcome !== "pending") return t(`home.result.${outcome}`);
  if (status === "in_progress") return t("home.result.pending");
  if (status === "cancelled") return t("home.state.cancelled");
  return t("home.state.waiting");
}
